import styled from '@emotion/styled';

import {SizeTokenValue} from 'common';
import {Loader as BaseLoader} from 'Loader';

import type {ButtonStyles} from '../types';

const Container = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  min-width: 18px;
  min-height: 18px;
`;

export const Loader: React.FC<ButtonStyles> = props => {
  if (!props.isLoading) {
    return null;
  }

  return (
    <Container>
      <BaseLoader color="inherit" size={SizeTokenValue.Small} />
    </Container>
  );
};
